package mapsearch.zones

import apiclient.geoobjects.LatLon
import apiclient.geoobjects.pointCoordinates
import com.jillesvangurp.geo.tiles.Tile
import com.jillesvangurp.geo.tiles.parentTiles
import com.jillesvangurp.geo.tiles.tiles
import dev.fritz2.core.RootStore
import kotlinx.coroutines.Job
import mapsearch.tile


class ZoneTilesLookUpStore : RootStore<Map<Tile, Set<String>>>(emptyMap(), Job()) {

    fun updateZoneInTileLookUp(zoneId: String, zoneLatLon: LatLon) {
        // find all required tiles for the new zoneId @ latLon
        val requiredTiles = mutableMapOf<Tile, Set<String>>().findAndAddTiles(
            idPositions = mapOf(zoneId to zoneLatLon),
            maxZoom = 22,
        ).keys.toMutableSet()

        val updatedTileMap = current.toMutableMap()

        current.keys.forEach { tile ->
            if (tile in requiredTiles) {
                // add id to existing required tile
                updatedTileMap[tile] = updatedTileMap[tile].orEmpty() + zoneId
                // then remove this tile from required tiles
                requiredTiles.remove(tile)
            } else if (updatedTileMap[tile]?.contains(zoneId) == true) {
                // remove id from not required tile
                updatedTileMap[tile] = updatedTileMap[tile].orEmpty() - zoneId
                // and remove not required tile if it is now empty
                if (updatedTileMap[tile].isNullOrEmpty()) {
                    updatedTileMap.remove(tile)
                }
            }
        }.also {
            // add remaining required tiles
            requiredTiles.forEach { remainingTile ->
                updatedTileMap[remainingTile] = setOf(zoneId)
            }
        }.also {
            update(updatedTileMap)
        }
    }

    // Zones to add [zoneId, latLon]
    fun add(zones: Map<String, LatLon>, maxZoom: Int = 22) {
        update(current.toMutableMap().findAndAddTiles(zones, maxZoom))
    }

    // Zones to remove [zoneId, latLon]
    fun remove(zones: Map<String, LatLon>) {
        val tileMap = current.toMutableMap()
        zones.forEach { (zoneId, zoneLatLon) ->
            zoneLatLon.pointCoordinates().tiles().forEach { tile ->
                tileMap[tile] = tileMap[tile].orEmpty() - zoneId
            }
        }
        update(tileMap)
    }

    private fun MutableMap<Tile, Set<String>>.findAndAddTiles(
        idPositions: Map<String, LatLon>,
        maxZoom: Int = 22
    ): Map<Tile, Set<String>> {
        idPositions.forEach { (id, latLon) ->
            val tileWithZonesAtMaxZoom = latLon.tile(maxZoom)
            (tileWithZonesAtMaxZoom.parentTiles() + tileWithZonesAtMaxZoom).map { tile ->
                this[tile] = this[tile].orEmpty() + id
            }
        }
        return this.toMap()
    }
}
